import { render } from "./layout.vue?vue&type=template&id=bdb2696c"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=bdb2696c&lang=css"
import "./layout.vue?vue&type=style&index=1&id=bdb2696c&lang=sass"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__